import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";
import PageWrapper from "../component/sharedComponents/PageWrapper";

const MessagesPage = () => {
    return (
        <PageWrapper
            title="Messages"
            subtitle="Your recent conversations"
            icon={ChatBubbleLeftRightIcon}
        >
            {[1, 2, 3].map((chat) => (
                <div
                    key={chat}
                    className="flex items-center gap-4 p-4 transition-colors border cursor-pointer border-border-light bg-bg-light-secondary rounded-xl dark:bg-bg-dark-secondary dark:border-border-dark hover:bg-gray-100 dark:hover:bg-gray-800"
                >
                    <img
                        src="https://i.pravatar.cc/50"
                        alt="Avatar"
                        className="w-12 h-12 border-2 rounded-full border-border-light dark:border-border-dark"
                    />
                    <div className="flex-1">
                        <p className="font-semibold text-gray-900 dark:text-gray-100">
                            Sarah Chen
                        </p>
                        <p className="text-sm text-gray-500 truncate dark:text-gray-400">
                            Hey! Did you see the latest news?
                        </p>
                    </div>
                    <span className="text-xs text-gray-500 dark:text-gray-400">2m</span>
                </div>
            ))}
        </PageWrapper>
    );
};

export default MessagesPage;
